"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7558],{

/***/ 87558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Features = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-white border border-gray-700 w-full lg:w-[48%] flex flex-col p-4 gap-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "border-b border-gray-300 text-lg font-normal ",
                children: "Features And Finishes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-justify",
                children: props.features
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Features);


/***/ })

}]);